import { UtenteVO } from "./utenteVO";
import { TipoElementoEnum } from "../enum/tipo-elemento-enum";
import { TipoVisibilitaEnum } from "../enum/tipo-visibilita-enum";
import {ListaVisibilitaVO} from "@vo/lista-visibilita/lista-visibilitaVO";
import {SettoreVO} from "@vo/settoreVO";

export class VisibilitaRequestVO {

    utente: UtenteVO;

    idElemento: string;
    settore: SettoreVO;
    tipoElemento: TipoElementoEnum;
    trasmettiAiFigli: boolean = false;
    tipoVisibilita: TipoVisibilitaEnum;
    gruppoVisibilita: ListaVisibilitaVO;
}
